export { getDynamicVariable } from "./dynamicVariables";
